import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/common/ui/Button';
import { RequestsActions } from '../../_store/Requests.slice';
import RadioButtonGroup from '../../components/common/ui/Inputs/RadioInput';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import CustomInput from '../../components/common/CustomInput';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import CustomModal from '../../components/common/CustomModal ';
import LegalResearchRequestSchema from '../../validation/LegalResearchRequestSchema';
import '../../css/LegalResearchRequest.css'
import TranslateFile from '../../Loc/TranslateFile';
import { getStoredValue  } from "../../_helpers/storageHelper";

const LegalResearchRequest = ({ selectformcategory, handleBack, isEdit, selectrowItem }) => {
    const currentLang = TranslateFile();
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const { IRRequestFormCUDResponse, InmateRequestIRRequestFormResponse } = useSelector(state => state.Requests);
    const { WhoSendOptions, ConvictedOptions, ResearchingOptions, LawyerTypeOptions, JurisdictionOptions } = useSelector(state => state?.dropdownOptions)
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const nameParts = storedloginResponse?.InmateFullName.trim().split(' ');
    const [formData, setFormData] = useState({
        firstName: nameParts.length > 1 ? nameParts[nameParts.length - 1] : '', lastName: nameParts[0] || "",
        middleInitial: '',
        inmateID: storedloginResponse?.InmateID,
        housingUnit: '',
        whoSent: '',
        specifyOther: '',
        month: '', day: '', year: '',
        currentCharges: '',
        convicted: '',
        sentenced: '',
        researching: '',
        proSe: '',
        isLawyerRepresenting: '',
        lawyerType: '',
        jurisdiction: '',
        otherState: '', information1: '', information2: '', information3: '', information4: '', information5: ''
    });
    const [isproceedform, setisproceedform] = React.useState(isEdit ? true : false);
    const [currentField, setCurrentField] = useState('');
    const [showBoard, setShowBoard] = useState(false);
    const allFields = ["specifyOther", 'month', 'day', 'year', 'currentCharges', "otherState", "information1", "information2",
        "information3", "information4", "information5"
    ];
    const formFields = ["specifyOther", 'month', 'day', 'year', 'currentCharges', 'convicted', "otherState", "information1", "information2",
        "information3", "information4", "information5"
    ];
    const [requireFields, setrequireFields] = useState(["information1"]);
    const [values, setvalues] = useState();
    const [errorMessage, setErrorMessage] = useState({});
    const [issubmit, setissubmit] = React.useState(false);
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setmodalContent] = useState("");
    const [modalContentColor, setmodalContentColor] = useState("");
    const placeholder = {
        specifyOther: "  ", month: "MM", day: "DD", year: "YYYY", currentCharges: "  ", otherState: " ", information1: " ",
        information2: " ", information3: " ", information4: " ", information5: " "
    }
    const [errors, seterrors] = useState({});

    useEffect(() => {
        if (IRRequestFormCUDResponse?.length !== 0 && issubmit) {
            switch (IRRequestFormCUDResponse) {
                case 1:
                    setmodalContent(currentLang?.AlertPopup?.Request_Submit_Success); setmodalContentColor('#4a9a93');
                    break;
                case 2:
                    setmodalContent(currentLang?.AlertPopup?.Remedy_Form_Submit_Success); setmodalContentColor('#4a9a93')
                    break;
                case -1:
                    setmodalContent(currentLang?.AlertPopup?.Please_Try_Again); setmodalContentColor('#c8605e')
                    break;
            }
            setShowPopup(true); setissubmit(false);
        }
    }, [IRRequestFormCUDResponse, issubmit]);

    const validateDate = () => {
        const { year, month, day } = formData;

        seterrors((prevErrors) => {
            let updatedErrors = { ...prevErrors };

            if (year && month && day) {
                updatedErrors.dateError = ""; // No error
            }
            else if (!year && !month && !day) {
                updatedErrors.invalidday = "";
                updatedErrors.invalidMonth = "";
                updatedErrors.invalidyear = ""
            }
            else if (year && !month && !day) {
                updatedErrors.invalidday = currentLang?.ValidationSchema?.Please_Enter_Day;
                updatedErrors.invalidMonth = currentLang?.ValidationSchema?.Please_Enter_Month;
                updatedErrors.invalidyear = ""
            }
            else if (year && month && !day) {
                updatedErrors.invalidday = currentLang?.ValidationSchema?.Please_Enter_Day;
            } else if (year && day && !month) {
                updatedErrors.invalidMonth = currentLang?.ValidationSchema?.Please_Enter_Month;
            } else if (month && (!year || year.length < 4) && !day) {
                updatedErrors.invalidyear = currentLang?.ValidationSchema?.Year_Validation;
                updatedErrors.invalidday = currentLang?.ValidationSchema?.Please_Enter_Day;
            } else if (month && (!year || year.length < 4)) {
                updatedErrors.invalidyear = currentLang?.ValidationSchema?.Year_Validation;
            } else if (month && !day) {
                updatedErrors.invalidday = currentLang?.ValidationSchema?.Please_Enter_Day;
            }
            else if (day && !month && !year) {
                updatedErrors.invalidMonth = currentLang?.ValidationSchema?.Please_Enter_Month;
                updatedErrors.invalidyear = currentLang?.ValidationSchema?.Please_Enter_Year
            }
            else if (day && !month) {
                updatedErrors.invalidMonth = currentLang?.ValidationSchema?.Please_Enter_Month;
            } else if (day && (!year || year.length < 4)) {
                updatedErrors.invalidyear = currentLang?.ValidationSchema?.Year_Validation;
            } else {
                updatedErrors.dateError = ""; // No error message
            }

            return updatedErrors;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        await validateDate();
        if (errors.invalidMonth || errors.invalidday || errors.invalidyear) {
            return;
        }
        setErrorMessage({});
        const { error } = LegalResearchRequestSchema(formData);
        if (error) {
            error.details.forEach((e) => {
                if (e.path.toString() == 'specifyOther' || e.path.toString() == 'otherState' || e.path.toString() == 'information1') {
                    handleFieldClick(e.path.toString())
                }
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }

        const apiPayload = {
            irRequestFormTypeID: 0,
            requestFormTypeID: selectformcategory, // Define or map it as needed
            facilityID: storedloginResponse?.facilityID,  // Define or map it as needed
            inmatesId: storedloginResponse?.InmateID,
            inmateID: storedloginResponse?.InmateID,
            inmateResidentID: storedloginResponse?.InmatesResdId || '',  // Mapping from state
            firstName: formData.firstName || '',
            middleName: formData.middleInitial || '',
            lastName: formData.lastName || '',
            housingUint: storedLoginDetails?.PodCode || '',
            irrfWhoSentID: formData.whoSent || 0,  // ID mapping if needed, replace '0' with real data
            whoSent: formData.specifyOther || '',
            nextCourtDate: (formData?.year && formData?.month && formData?.day) ? new Date(formData?.year, formData?.month - 1, formData?.day).toDateString() : '',  // Format MM/DD/YYYY
            currentCharges: formData.currentCharges || '',
            isConvicted: formData.convicted,  // Assuming Yes/No values
            isSentenced: formData.sentenced,  // Assuming Yes/No values
            irrfResearchReasonID: formData.researching || 0,  // ID for research reason
            researchReason: ResearchingOptions?.find(x => x?.value == formData.researching)?.label || "",  // Fill if needed
            isProSe: formData.proSe,  // Assuming Yes/No values
            isLawyerRepresent: formData.isLawyerRepresenting,  // Assuming Yes/No values
            ifIsLawyerRepresent: formData.lawyerType || 0,  // Assuming ID mapping for lawyer type
            irrfJurisdictionReasonID: formData.jurisdiction || 0,  // Jurisdiction ID mapping
            jurisdictionReason: formData?.otherState || '',  // Fill if needed
            information1: formData?.information1 || '',
            information2: formData?.information2 || '',
            information3: formData?.information3 || '',
            information4: formData?.information4 || '',
            information5: formData?.information5 || '',
            createdBy: 0,  // Define as needed
            action: 1,  // Define as needed
            isSucced: 1  // Define as needed
        };
        dispatch(RequestsActions.loadIRRequestFormCUD(apiPayload));
        setissubmit(true);
        // Add validation and form submission logic here
    };

    useEffect(() => {
        if (isEdit && InmateRequestIRRequestFormResponse?.length > 0) {
            const EditResponse = InmateRequestIRRequestFormResponse[0];

            // Set the main form fields
            setFormData(prevFormData => ({
                ...prevFormData,
                firstName: EditResponse?.FirstName || '',
                lastName: EditResponse?.LastName || '',
                middleInitial: EditResponse?.MiddleName || '',
                inmateID: EditResponse?.InmateID || '',
                housingUnit: EditResponse?.HousingUint || '',
                whoSent: EditResponse?.IRRFWhoSentID || '',
                specifyOther: EditResponse?.IRRFWhoSentID === 6 ? EditResponse?.WhoSent : '',
                month: '',
                day: '',
                year: '',
                currentCharges: EditResponse?.CurrentCharges || '',
                convicted: EditResponse?.IsConvicted || 0,
                sentenced: EditResponse?.IsSentenced || 0,
                researching: EditResponse?.IRRFResearchReasonID || '0',
                proSe: EditResponse?.IsProSe || 0,
                isLawyerRepresenting: EditResponse?.IsLawyerRepresent || 0,
                lawyerType: '0',
                jurisdiction: EditResponse?.IRRFJurisdictionReasonID || '',
                otherState: EditResponse?.IRRFJurisdictionReasonID === 7 ? EditResponse?.JurisdictionReason : '',
                information1: EditResponse?.Information1 || '',
                information2: EditResponse?.Information2 || '',
                information3: EditResponse?.Information3 || '',
                information4: EditResponse?.Information4 || '',
                information5: EditResponse?.Information5 || ''
            }));

            // Handle the date parts (NextCourtDate)
            if (EditResponse?.NextCourtDate) {
                const courtDateParts = EditResponse.NextCourtDate.split('/');
                if (courtDateParts.length === 3) {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        month: courtDateParts[0],
                        day: courtDateParts[1],
                        year: courtDateParts[2]
                    }));
                }
            }
        }
    }, [isEdit, InmateRequestIRRequestFormResponse]);

    useEffect(() => {
        if (isEdit) {
            if (selectrowItem?.RequestFormType) {
                dispatch(RequestsActions.loadInmateRequestIRRequestForm(selectrowItem?.RequestFormTypeID))
            }
        }
    }, [isEdit]);

    const handleDateChange = (id, value) => {
        seterrors((errors) => {
            let updatedErrors = { ...errors };

            if (id === "month") {
                if (value?.trim().length === 0) {
                    updatedErrors.invalidMonth = "";
                }
                else if (!/^(0[1-9]|1[0-2])$/.test(value)) {
                    updatedErrors.invalidMonth = currentLang?.ValidationSchema?.Month_Format;
                } else {
                    updatedErrors.invalidMonth = "";
                }
            }

            else if (id === "day") {
                if (value?.trim().length === 0) {
                    updatedErrors.invalidday = "";
                }
                else if (!/^(0[1-9]|[12][0-9]|3[01])?$/.test(value)) {
                    updatedErrors.invalidday = currentLang?.ValidationSchema?.Day_Format;
                } else {
                    updatedErrors.invalidday = "";
                }
            }

            else if (id === "year") {
                if (value?.trim().length === 0) {
                    updatedErrors.invalidyear = "";
                }
                else if (!/^(19|20)\d{2}$/.test(value)) {
                    updatedErrors.invalidyear = currentLang?.ValidationSchema?.Year_Format;
                } else {
                    updatedErrors.invalidyear = "";
                }
            }
            return updatedErrors;
        });
    };

    const handleFieldClick = (field) => {
        setCurrentField(field);
        setShowBoard(true); // Show the keyboard when a field is clicked
        setvalues(formData);
    };
    return (
        <>
            <div className="panel panel-default">
                {showPopup && (
                    <CustomModal
                        color={modalContentColor}
                        content={modalContent}
                        onOkClick={() => handleBack()}
                    />
                )}
                {!isproceedform ? <div className="panel-body">
                    <div className="innerContent" id="divContent">
                        <article>
                            <h1 className='header-title'>
                                {currentLang?.LegalForm?.LegalForm_Header}
                            </h1>
                            <h2 className="subheader-title">
                                {currentLang?.LegalForm?.LegalForm_SubHeader}
                            </h2>
                            <p className="form-description">
                                {currentLang?.LegalForm?.LegalForm_Description}
                            </p>
                            <p className="form-tips">
                                {currentLang?.LegalForm?.LegalForm_Tips}
                            </p>
                            <ul className="form-guidelines">
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines1}</li>
                                <li className="form-tips">{currentLang?.LegalForm?.LegalForm_Guidelines2}</li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines3}</li>
                                <li className="warning-text">
                                    {currentLang?.LegalForm?.LegalForm_Guidelines4}
                                </li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines5}</li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines6}</li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines7}</li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines8}</li>
                                <li>{currentLang?.LegalForm?.LegalForm_Guidelines9}</li>
                            </ul>
                            <div className="button-container">
                                <Button
                                    variant="success"
                                    className="proceed-button"
                                    label={currentLang?.Buttons?.PROCEED_TO_FORM}
                                    type="button"
                                    status="success"
                                    disabled={false}
                                    onClick={() => setisproceedform(true)}
                                />
                            </div>
                        </article>
                    </div>

                </div> :
                    <div className="innerContent">
                        <article>
                            <h1 className='header-title'>
                                {currentLang?.LegalForm?.LegalForm_Header}
                            </h1>
                            <h2 className='subheader-title'>
                                {currentLang?.LegalForm?.Legal_Information_Request_Form}
                            </h2>
                            <form onSubmit={handleSubmit}>
                                <div className="col-md-12">
                                    <div className='row'>
                                        <div className="col-md-4">
                                            <CustomInput
                                                required={true}
                                                label={currentLang?.TableHeaders?.Last_Name}
                                                type="text"
                                                placeholder={currentLang?.MyInvites?.LastName_Placeholder}
                                                id="inviteFirstName"
                                                value={formData?.lastName}
                                                isdisabled={true}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <CustomInput
                                                required={true}
                                                label={currentLang?.TableHeaders?.First_Name}
                                                type="text"
                                                placeholder={currentLang?.MyInvites?.FirstName_Placeholder}
                                                id="inviteFirstName"
                                                value={formData?.firstName}
                                                isdisabled={true}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <CustomInput
                                                label={currentLang?.Labels?.Middle_Initial}
                                                type="text"
                                                id="inviteFirstName"
                                                value={formData?.middleInitial}
                                                isdisabled={true}
                                            />
                                        </div></div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <CustomInput
                                                required={true}
                                                label={currentLang?.Labels?.Inmate_ID}
                                                type="text"
                                                placeholder={"Enter Inmate ID"}
                                                id="inviteFirstName"
                                                value={storedloginResponse?.InmatesResdId}
                                                isdisabled={true}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <CustomInput
                                                required={true}
                                                label={currentLang?.Labels?.Housing_Unit}
                                                type="text"
                                                placeholder={"Enter Housing Unit"}
                                                id="inviteFirstName"
                                                value={isEdit ? InmateRequestIRRequestFormResponse[0]?.HousingUint : storedLoginDetails?.PodCode}
                                                isdisabled={true}
                                            />
                                        </div></div>

                                    <div className="col-md-12">
                                        <div className="d-flex flex-column">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible mb-0">{currentLang?.Labels?.Who_sent_you_to_this_prison}<span className="mandatory">*</span></label>
                                            <RadioButtonGroup
                                                //required={true}
                                                //label="Who sent you to this prison?"
                                                name="whoSent" // Changed to "whoSent" to match the state field
                                                options={WhoSendOptions}
                                                selectedValue={formData.whoSent}

                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        whoSent: parseInt(e.target.value) // Update the whoSent field
                                                    })); setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        whoSent: "", specifyOther: (e.target.value == 6 && formData.specifyOther?.trim()?.length == 0) ? "Please Enter the Field." : ""
                                                    })));
                                                    setrequireFields(["information1", e.target.value == 6 && "specifyOther", formData.jurisdiction == 7 && "otherState"])
                                                }}
                                                disabled={isEdit ? true : false}
                                                errorMessage={errorMessage}
                                            />

                                        </div>

                                    </div>


                                    <div className="col-md-12" id="divOthers">
                                        <div className="form-group">
                                            <CustomInput
                                                label={currentLang?.Labels?.Specify_Other}
                                                type="text"
                                                // placeholder={"EnterSpecify 'Other'"}
                                                id="inviteFirstName"
                                                value={formData.specifyOther}
                                                onClick={() => handleFieldClick('specifyOther')}
                                                isdisabled={(isEdit) ? true : false}
                                                errorMessage={errorMessage?.specifyOther}
                                            />

                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.Next_Court_Date}</label>
                                            <div style={{ display: 'flex' }}>
                                                <div className='col-md-3'>
                                                    <CustomInput
                                                        type="text"
                                                        placeholder={"MM"}
                                                        id="month"
                                                        isShowError
                                                        errorMessage={errors?.invalidMonth}
                                                        value={formData.month}
                                                        isdisabled={isEdit ? true : false}
                                                        onClick={() => handleFieldClick('month')}
                                                    /></div>
                                                <span style={{
                                                    width: '20px',
                                                    height: '30px',
                                                    textAlign: 'center',
                                                    lineHeight: '35px',
                                                    fontSize: '16px',
                                                    color: '#000',
                                                    padding: '3px'
                                                }}>/</span>
                                                <div className='col-md-3'>
                                                    <CustomInput
                                                        type="text"
                                                        placeholder={"DD"}
                                                        value={formData.day}
                                                        id="day"
                                                        isShowError
                                                        errorMessage={errors?.invalidday}
                                                        onClick={() => handleFieldClick('day')}
                                                        isdisabled={isEdit ? true : false}
                                                    /></div>
                                                <span style={{
                                                    width: '20px',
                                                    height: '30px',
                                                    textAlign: 'center',
                                                    lineHeight: '35px',
                                                    fontSize: '16px',
                                                    color: '#000',
                                                    padding: '3px'
                                                }}>/</span>
                                                <div className='col-md-3'>
                                                    <CustomInput
                                                        type="text"
                                                        placeholder={"YYYY"}
                                                        value={formData.year}
                                                        isShowError
                                                        errorMessage={errors?.invalidyear}
                                                        id="year"
                                                        onClick={() => handleFieldClick('year')}
                                                        isdisabled={isEdit ? true : false}
                                                    /></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <CustomInput
                                            label={currentLang?.Labels?.List_Your_Current_Charges}
                                            type="text"
                                            // placeholder={"List your current charges"}
                                            id="inviteFirstName"
                                            value={formData.currentCharges}
                                            isdisabled={isEdit ? true : false}
                                            onClick={() => handleFieldClick('currentCharges')}
                                            errorMessage={errorMessage.currentCharges}
                                        />
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.Have_You_been_Convicted}<span className="mandatory">*</span></label>
                                            <RadioButtonGroup
                                                // required={true}
                                                // label="Have you been convicted?"
                                                name="convicted"  // Changed to "convicted" to reflect the field being updated
                                                options={ConvictedOptions}
                                                disabled={isEdit ? true : false}
                                                selectedValue={parseInt(formData.convicted)}
                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        convicted: parseInt(e.target.value)  // Update the convicted field
                                                    }));
                                                    setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        convicted: ""
                                                    })))
                                                }
                                                }
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.If_Convicted}<span className="mandatory">*</span></label>
                                            <RadioButtonGroup
                                                //required={true}
                                                //label="If convicted, have you been sentenced?"
                                                name="sentenced"  // Changed to "sentenced" to reflect the field being updated
                                                options={ConvictedOptions}
                                                disabled={isEdit ? true : false}
                                                selectedValue={parseInt(formData.sentenced)}
                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        sentenced: parseInt(e.target.value)  // Update the sentenced field
                                                    }))
                                                        ;
                                                    setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        sentenced: ""
                                                    })))
                                                }
                                                }
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <SelectInput
                                            required={true}
                                            options={ResearchingOptions}
                                            label={currentLang?.Labels?.I_Am_Researching}
                                            name="researching"
                                            id="researching"
                                            labelKey="label"
                                            valueKey="value"
                                            value={formData.researching}
                                            isClearable={false}
                                            isDisabled={isEdit ? true : false}
                                            handleChange={(e) => {
                                                setFormData({ ...formData, ['researching']: e.value });
                                                setErrorMessage((prevData => ({
                                                    ...prevData,
                                                    researching: e.value ? "" : "Please select the Field"
                                                })))
                                            }
                                            }
                                            errorMessage={errorMessage}
                                        />

                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.Pro_Se}<span className="mandatory">*</span></label>
                                            <RadioButtonGroup
                                                // required={true}
                                                // label="Are you 'Pro Se' in the matter you are researching? ('Pro Se' means you are representing yourself.)"
                                                name="proSe"  // Unique name for this group
                                                options={ConvictedOptions}
                                                disabled={isEdit ? true : false}
                                                selectedValue={parseInt(formData.proSe)}
                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        proSe: parseInt(e.target.value)  // Update proSe field
                                                    }))
                                                        ;
                                                    setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        proSe: ""
                                                    })))
                                                }
                                                }
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.I_Am_Not_Pro_Se}<span className="mandatory">*</span></label>
                                            <RadioButtonGroup
                                                // required={true}
                                                // label="If not 'Pro Se', do you have a lawyer currently representing you in this matter?"
                                                name="isLawyerRepresenting"  // Unique name for this group
                                                options={ConvictedOptions}
                                                disabled={isEdit ? true : false}
                                                selectedValue={parseInt(formData.isLawyerRepresenting)}
                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        isLawyerRepresenting: parseInt(e.target.value)  // Update isLawyerRepresenting field
                                                    }))
                                                        ;
                                                    setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        isLawyerRepresenting: ""
                                                    })))
                                                }
                                                }
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.The_Lawyer}<span className="mandatory">*</span> </label>
                                            <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">{currentLang?.Labels?.Choose_one}</label>
                                            <RadioButtonGroup
                                                required={false}
                                                disabled={isEdit ? true : false}
                                                //label="Choose one:"
                                                name="lawyerType"  // Unique name for this group
                                                options={LawyerTypeOptions}
                                                selectedValue={parseInt(formData.lawyerType)}
                                                handleChange={(e) => {
                                                    setFormData(prevData => ({
                                                        ...prevData,
                                                        lawyerType: parseInt(e.target.value)  // Update lawyerType field
                                                    }))
                                                        ;
                                                    setErrorMessage((prevData => ({
                                                        ...prevData,
                                                        lawyerType: ""
                                                    })))
                                                }
                                                }
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-12">
                                        <SelectInput
                                            options={JurisdictionOptions}
                                            label={currentLang?.Labels?.Jurisdiction}
                                            name="jurisdiction"
                                            id="jurisdictionOptions"
                                            labelKey="label"
                                            valueKey="value"
                                            value={formData.jurisdiction}
                                            isClearable={false}
                                            required
                                            isDisabled={isEdit ? true : false}
                                            handleChange={(e) => {
                                                setFormData({ ...formData, ['jurisdiction']: e.value });
                                                setErrorMessage((prevData => ({
                                                    ...prevData,
                                                    jurisdiction: e.value ? "" : "Please select the Field",
                                                    otherState: (e.value == 7 && formData.otherState?.trim()?.length == 0) ? "Please Enter the Field." : ""
                                                })));
                                                setrequireFields(["information1", formData.whoSent == 6 && "specifyOther", e.value == 7 && "otherState"])
                                            }}
                                            errorMessage={errorMessage}
                                        />
                                    </div>


                                    <div className="col-md-12">
                                        <CustomInput
                                            label={currentLang?.Labels?.Other_State}
                                            type="text"
                                            //placeholder={"Please indicate which 'Other State' if applicable."}
                                            id="inviteFirstName"
                                            value={formData.otherState}
                                            errorMessage={errorMessage.otherState}
                                            isdisabled={(isEdit) ? true : false}
                                            onClick={() => handleFieldClick('otherState')}
                                        />

                                    </div>


                                    <div className="col-md-12">
                                        <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
                                            {currentLang?.Labels?.List_Of_5_Items}<span className="mandatory">*</span>
                                        </label>
                                    </div>
                                    <div className="col-md-12">
                                        <CustomInput
                                            label={`1.`}
                                            type="text"
                                            // placeholder={"information1"}
                                            id="inviteFirstName"
                                            value={formData.information1}
                                            isdisabled={isEdit ? true : false}
                                            errorMessage={errorMessage.information1}
                                            onClick={() => handleFieldClick('information1')}
                                        />

                                    </div>

                                    <div className="col-md-12">
                                        <CustomInput
                                            label={`2.`}
                                            type="text"
                                            //placeholder={"information2"}
                                            id="inviteFirstName"
                                            value={formData.information2}
                                            isdisabled={isEdit ? true : false}
                                            onClick={() => handleFieldClick('information2')}
                                        />

                                    </div>
                                    <div className="col-md-12">
                                        <CustomInput
                                            label={`3.`}
                                            type="text"
                                            // placeholder={"information3"}
                                            id="inviteFirstName"
                                            value={formData.information3}
                                            isdisabled={isEdit ? true : false}
                                            onClick={() => handleFieldClick('information3')}
                                        />

                                    </div>
                                    <div className="col-md-12">
                                        <CustomInput
                                            label={`4.`}
                                            type="text"
                                            //placeholder={"information4"}
                                            id="inviteFirstName"
                                            value={formData.information4}
                                            isdisabled={isEdit ? true : false}
                                            onClick={() => handleFieldClick('information4')}
                                        />

                                    </div>
                                    <div className="col-md-12">
                                        <CustomInput
                                            label={`5.`}
                                            type="text"
                                            //placeholder={"information5"}
                                            id="inviteFirstName"
                                            value={formData.information5}
                                            isdisabled={isEdit ? true : false}
                                            onClick={() => handleFieldClick('information5')}
                                        />

                                    </div>

                                    {!isEdit && <div className="col-md-12">
                                        <p style={{ marginLeft: '30px', width: '95%', lineHeight: '25px' }}>
                                            {currentLang?.LegalForm?.LegalForm_Please_Note_By_Submit}
                                        </p>
                                        <p style={{ textAlign: 'center' }}>
                                            {currentLang?.LegalForm?.LegalForm_Confirm_Notice}
                                        </p>
                                        <p style={{ textAlign: 'center' }}>
                                            {currentLang?.LegalForm?.May_take_several_seconds}
                                        </p>
                                    </div>}
                                    {!isEdit && <div className="d-flex justify-content-center mt-30">
                                        <Button label={currentLang?.Buttons?.Submit} status="primary" type="submit" disabled={issubmit} isLoading={issubmit} />
                                    </div>
                                    }
                                </div>
                            </form>
                        </article>
                        {showBoard && (
                            <div className="card-default">
                                <CustomKeyboard
                                    currentField={currentField}
                                    setCurrentField={setCurrentField}
                                    inputs={formData}
                                    isTabKey={false}
                                    setShowBoard={setShowBoard}
                                    setInputs={setFormData}
                                    fields={allFields}
                                    placeholderList={placeholder}
                                    setErrorMessage={setErrorMessage}
                                    type="Multiple"
                                    setValues={setvalues}
                                    isonchangefunction={true}
                                    requireFields={requireFields}
                                    onInputChange={handleDateChange}
                                    allFields={formFields}
                                    handleCancel={() => { setFormData(values)}}
                                    isEnterKey={false}
                                />
                            </div>
                        )}
                    </div>

                }
            </div>
        </>
    );
};

export default memo(LegalResearchRequest);
